import { AgGridReact } from "ag-grid-react";
import { FC, ReactNode, RefObject, useCallback, useMemo } from "react";

export interface IconHeaderProps {
  icon: ReactNode;
  enableSorting: boolean;
  columnID: string;
  gridRef: RefObject<AgGridReact>;
}

export const IconHeader: FC<IconHeaderProps> = ({ icon, enableSorting, columnID, gridRef }) => {
  const sortColumn = useCallback(() => {
    const col = gridRef.current?.api.getColumn(columnID);
    const sort = col?.getSort() !== "asc" ? "asc" : "desc";
    gridRef.current?.api.applyColumnState({
      state: [{ colId: columnID, sort: sort }],
      defaultState: { sort: null },
    });
  }, [columnID, gridRef]);

  const sortEl = useMemo(
    () => {
      if (!enableSorting) {
        return <div>{icon}</div>;
      }

      return (
        <div onClick={sortColumn}>
          {icon}
        </div>
      );
    },
    [enableSorting, icon, sortColumn],
  );

  return (
    <div className="ag-cell-label-container">
      <span className="ag-header-icon"></span>
      <div className="ag-header-cell-label">
        {sortEl}
      </div>
    </div>
  );
};

